<template>
  <div class="contract-device-bd">
    <div class="change-title ub ub-sp" v-if="stateCodeDic.zlz">
      <el-radio-group v-model="formSearch.deviceState" @change="onPageChange({ page: 1 })">
        <el-radio-button :label="stateCodeDic.dfh" v-if="!detail.renewalOrderId">{{ $t('crm_contract_device.dai_fa_huo') }} ({{ countDetail[stateCodeDic.dfh] || 0 }})</el-radio-button>
        <el-radio-button :label="`${stateCodeDic.ztz},${stateCodeDic.dqz}`">
          {{ $t('crm_contract_device.wei_qi_zu') }} ({{ (+countDetail[stateCodeDic.ztz] || 0) + (+countDetail[stateCodeDic.dqz] || 0) }})
        </el-radio-button>
        <el-radio-button :label="stateCodeDic.zlz">{{ $t('crm_contract_device.zu_lin_zhong') }} ({{ countDetail[stateCodeDic.zlz] || 0 }})</el-radio-button>
        <el-radio-button :label="stateCodeDic.yzt">{{ $t('crm_contract_device.yi_zan_ting') }} ({{ countDetail[stateCodeDic.yzt] || 0 }})</el-radio-button>
        <el-radio-button :label="stateCodeDic.ygh">{{ $t('crm_contract_device.yi_geng_huan') }} ({{ countDetail[stateCodeDic.ygh] || 0 }})</el-radio-button>
        <el-radio-button :label="stateCodeDic.ywy">{{ $t('crm_contract_device.yi_wei_yue') }} ({{ countDetail[stateCodeDic.ywy] || 0 }})</el-radio-button>
        <el-radio-button :label="stateCodeDic.ydq">{{ $t('crm_contract_device.yi_dao_qi') }} ({{ countDetail[stateCodeDic.ydq] || 0 }})</el-radio-button>
      </el-radio-group>
      <search-input v-model="formSearch.search" :placeholder="$t('crm_contract_device.qsrsbjsh')" @fetch="onPageChange({ page: 1 })"></search-input>
    </div>
    <div class="table-bd" v-if="formSearch.deviceState">
      <!-- 待发货 -->
      <custom-table key="0" v-if="formSearch.deviceState === `${stateCodeDic.dfh}`" :data="tableList" tableCode="contractWaitDevice" @filter="filterChange" @sort="sortChange"></custom-table>
      <!-- 未启租 -->
      <custom-table key="1" v-if="formSearch.deviceState === `${stateCodeDic.ztz},${stateCodeDic.dqz}`" :data="tableList" tableCode="contractDevice" @filter="filterChange" @sort="sortChange">
        <template slot="action" slot-scope="scope">
          <span></span>
          <!-- 启租（只有售后和乙方可以启租） 试用合同：总部已收款hqReceiveState == 1 -->
          <el-button
            type="text"
            size="mini"
            v-if="
              (detail.bizClass != '10' || scope.row.hqReceiveState == 1 || scope.row.hasHqReceiveBill == 0) &&
              funcView.contractDetail_start &&
              rule.start &&
              `${scope.row.bizState}` === `${stateCodeDic.dqz}` &&
              bizClass &&
              (!scope.row.lastOrderDeviceId || (scope.row.lastOrderDeviceId && scope.row.lastBizState >= 43))
            "
            @click="handleDeviceStart(scope.row)"
          >
            {{ funcView.contractDetail_start }}
          </el-button>
          <!-- 收货（售后公司和乙方可以）-->
          <el-button
            type="text"
            size="mini"
            v-if="funcView.contractDetail_partybReceive && rule.partybReceive && `${scope.row.bizState}` === `${stateCodeDic.ztz}` && bizClass"
            @click="handleDeviceRecevice(scope.row)"
          >
            {{ $t('crm_contract_device.shou_huo') }}
          </el-button>
        </template>
      </custom-table>
      <!-- 租赁中 -->
      <custom-table
        key="2"
        v-if="formSearch.deviceState === stateCodeDic.zlz"
        :data="tableList"
        tableCode="contractDeviceList"
        :onlyArr="['deviceNo', 'bodyNum', 'productCode', 'deviceBizType', 'rentalTerm', 'paymentPeriod', 'unitPrice', 'giveawayMonth','depositFee', 'rentalStartTime', 'pauseDuration', 'endRentDate', 'action']"
      >
        <template slot="action" slot-scope="scope">
          <span></span>
          <el-button v-if="funcView.contractDetail_send_bill" type="text" size="mini" @click="onSendBill(scope.row)">{{ $t('crm_contract_device.xia_fa_zhang_dan') }}</el-button>
        </template>
      </custom-table>
      <!-- 已暂停 -->
      <custom-table
        key="3"
        v-if="formSearch.deviceState === stateCodeDic.yzt"
        :data="tableList"
        tableCode="contractDeviceList"
        :slots="['pauseDate', 'action']"
        :onlyArr="['deviceNo', 'bodyNum', 'productCode', 'deviceBizType', 'rentalTerm', 'paymentPeriod', 'unitPrice','giveawayMonth', 'depositFee', 'rentalStartTime', 'pauseDate', 'action']"
      >
        <!-- 暂停时间取changeDate -->
        <template slot="pauseDate" slot-scope="scope">
          <span>{{ $momentLocal(scope.row.changeDate, 'YYYY-MM-DD') }}</span>
        </template>
        <template slot="action" slot-scope="scope">
          <span></span>
          <el-button v-if="funcView.contractDetail_resume_use" type="text" size="mini" @click="recoveryUse(scope.row)">{{ funcView.contractDetail_resume_use }}</el-button>
        </template>
      </custom-table>
      <!-- 已更换 -->
      <custom-table
        key="4"
        v-if="formSearch.deviceState === stateCodeDic.ygh"
        :data="tableList"
        tableCode="contractDeviceList"
        :onlyArr="['deviceNo', 'bodyNum', 'productCode', 'deviceBizType', 'rentalTerm', 'paymentPeriod', 'unitPrice','giveawayMonth', 'depositFee', 'rentalStartTime', 'changeDate']"
      ></custom-table>
      <!-- 已违约 -->
      <custom-table
        key="5"
        v-if="formSearch.deviceState === stateCodeDic.ywy"
        :data="tableList"
        tableCode="contractDeviceList"
        :onlyArr="['deviceNo', 'bodyNum', 'productCode', 'deviceBizType', 'rentalTerm', 'paymentPeriod', 'unitPrice','giveawayMonth', 'depositFee', 'rentalStartTime', 'breakTime', 'deviceBackTime']"
      ></custom-table>
      <!-- 已到期 -->
      <custom-table
        key="6"
        v-if="formSearch.deviceState === stateCodeDic.ydq"
        :data="tableList"
        tableCode="contractDeviceList"
        :onlyArr="['deviceNo', 'bodyNum', 'productCode', 'deviceBizType', 'rentalTerm', 'paymentPeriod', 'unitPrice','giveawayMonth', 'depositFee', 'rentalStartTime', 'endRentDate', 'recoverPswd']"
      ></custom-table>
    </div>
    <!-- 设备类型 deviceBizType -->
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  name: '',
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
    rule: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      contractStatus: 'all',
      stateCodeDic: {},
      countDetail: {},
      bizClass: '',
      formSearch: {
        bizId: '',
        deviceState: '',
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
      },
      tableList: [],
      totalRows: 0,
      classMap: {
        leasing_contract: 20, // 租赁合同
        lease_renewal_contract: 21, // 续租租赁
        frame_contract: 30, // 框架协议
        frame_order: 31, // 协议订单
        trail_order: 10, // 试用订单
      },
    };
  },
  mounted: function () {
    this.formSearch.bizId = this.getJump('contractId');
    this.bizClass = this.getJump('contractClass');
    const approveType = this.getJump('approveType');
    if (approveType && !this.bizClass) {
      this.bizClass = this.classMap[approveType];
    }
    this.getTableCount();
    this.getFuncView();
    this.getDictionary('order_device_biz_state', (data) => {
      this.stateCodeDic = this.$listTransObject(data.order_device_biz_state, 'code', 'value');
      this.formSearch.deviceState = `${this.stateCodeDic.ztz},${this.stateCodeDic.dqz}`;
      this.getTableList();
    });
    this.Bus.$on('contract_device', () => {
      this.getTableCount();
      this.getTableList();
    });
  },
  methods: {
    // 获取表格数据列表
    getTableList: function () {
      // 是否是待发货
      const isWait = this.formSearch.deviceState === this.stateCodeDic.dfh;
      if (isWait) {
        this.formSearch.bizClass = this.bizClass;
        this.$getJSON(apis.crmContractListScheme, this.formSearch).then((res) => {
          this.tableList = res.data.goodsList || [];
          this.totalRows = null;
        });
        return;
      }
      this.$getJSON(apis.ContractDevicePage, this.formSearch).then((res) => {
        const list = res.data.list || [];
        list.forEach((item) => {
          item.breakTime = item.endRentDate;
          // 已到期-到期日期字段用deviceBackTime
          if (this.formSearch.deviceState === this.stateCodeDic.ydq) {
            item.endRentDate = item.deviceBackTime;
          }
        });
        this.tableList = list;
        this.totalRows = res.data.total;
      });
    },
    // 获取表格数据数量
    getTableCount: function () {
      this.$getJSON(apis.ContractDeviceCount, { bizId: this.formSearch.bizId }).then((res) => {
        this.countDetail = res.data || {};
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 收货
    handleDeviceRecevice: function (item) {
      this.$confirm(this.$t('crm_contract_device.nqdydgspzshczm'), this.$t('Common.com_reminder'), {
        confirmButtonText: this.$t('Common.com_confirm'),
        cancelButtonText: this.$t('Common.com_cancel'),
        closeOnClickModal: false,
        type: 'warning',
      })
        .then(() => {
          const deviceList = [
            {
              bodyNum: item.bodyNum,
              deviceId: item.deviceId,
              productCode: item.productCode,
            },
          ];
          this.$postJSON(apis.contractReceive, {
            bizId: this.formSearch.bizId,
            bizClass: this.bizClass,
            deviceList: deviceList,
            operateType: 2,
          }).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.tableList = [];
            this.totalRows = 0;
            this.getTableList();
            this.getTableCount();
            this.$emit('success');
          });
        })
        .catch(() => {});
    },
    // 格式化起租时间
    formatStartLeaseTime: function (dateTime) {
      if (!dateTime) {
        return null;
      }
      const year = this.$moment.utc(dateTime).year();
      const nowYear = this.$moment.utc().year();
      const month = this.$moment.utc(dateTime).month();
      const nowMonth = this.$moment.utc().month();
      if (year < nowYear || (year === nowYear && month < nowMonth)) {
        return this.$moment.utc(this.$moment.utc().format('YYYY-MM-01 00:00:00')).format('YYYY-MM-DD HH:mm');
      }
      return this.$moment.utc(dateTime).format('YYYY-MM-DD HH:mm');
    },
    // 启租
    handleDeviceStart: function (item) {
      this.$confirm(this.$t('crm_contract_device.nqdydgsbzqzczm'), this.$t('Common.com_reminder'), {
        confirmButtonText: this.$t('Common.com_confirm'),
        cancelButtonText: this.$t('Common.com_cancel'),
        closeOnClickModal: false,
        type: 'warning',
      })
        .then(() => {
          // v2版本 新加计划日期
          this.$postJSON(apis.contractDeviceStart2, {
            bodyNum: item.bodyNum,
            contractType: this.bizClass,
            deviceNo: item.deviceNo,
            orderId: this.formSearch.bizId,
            startLeaseTime: this.formatStartLeaseTime(item.planRentalStartTime),
          }).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.tableList = [];
            this.totalRows = 0;
            this.getTableList();
            this.getTableCount();
            this.$emit('success');
          });
        })
        .catch(() => {});
    },
    // 下发账单
    onSendBill: function (item) {
      this.$confirm(this.$t('crm_contract_device.nqdydgsbzxfzdczm'), this.$t('Common.com_reminder'), {
        confirmButtonText: this.$t('Common.com_confirm'),
        cancelButtonText: this.$t('Common.com_cancel'),
        closeOnClickModal: false,
        type: 'warning',
      })
        .then(() => {
          this.$postJSON(`${apis.deviceFeignCommandTask}/${item.orderId}/${item.deviceNo}`).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            // this.getTableList();
            // this.getTableCount();
            // this.$emit('success');
          });
        })
        .catch(() => {});
    },
    // 恢复使用
    recoveryUse: function (item) {
      this.$confirm(this.$t('crm_contract_device.nqdydgsbzhfsyczm'), this.$t('Common.com_reminder'), {
        confirmButtonText: this.$t('Common.com_confirm'),
        cancelButtonText: this.$t('Common.com_cancel'),
        closeOnClickModal: false,
        type: 'warning',
      })
        .then(() => {
          this.$postJSON(`${apis.contractEndPauseUse}/${this.formSearch.bizId}/${item.deviceId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
            this.getTableCount();
            this.$emit('success');
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';

.contract-device-bd {
  background-color: #ffffff;
  padding: 0 24px;
  .change-title {
    padding: 24px 0;
  }
}
</style>
